import { Contract } from './contract';
import { Model } from './model';

export class InvoiceSetup extends Model {

  invoiceNumber?: string;
  id?: number;
  addressLine1?: string;
  city?: string;
  codeSDI?: string;
  country?: string;
  description?: string;
  email?: string;
  identifier?: string;
  pec?: string;
  phone?: string;
  vatNumber?: string;
  zipCode?: string;
  contractId?: number;
  month?: number;
  type?: number;
  isPayed?: boolean;
  invoiceItem?: [];
  contract?: Contract;
}
